import { useCallback } from 'react'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { useSWRConfig } from 'swr'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { useCoursePathKey } from '../hooks/use-course-data'
import { CourseDataInterface } from '../types/course-interface'
import { CourseQuizTrackingSessionCreateInterface } from '../types/course-lecture-interface'
import { TrackingApi } from './session-logging-api'

export const useCreateQuizTrackingSession = (): UseMutationResult<
  CourseQuizTrackingSessionCreateInterface,
  Error,
  number
> => {
  const { mutate } = useSWRConfig()
  const courseDataKey = useCoursePathKey()
  const accessDeniedResponseHandler = useCallback(() => null, [])

  const lockedResponseHandler = useCallback(
    () =>
      mutate(
        courseDataKey,
        (data?: CourseDataInterface) => (data ? { ...data, lectureSessionLogging: false } : data),
        { revalidate: true },
      ),
    [courseDataKey, mutate],
  )

  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.post,
    CourseQuizTrackingSessionCreateInterface
  >({
    method: RequestMethodsEnum.post,
    accessDeniedResponseHandler,
    lockedResponseHandler,
  })

  return useMutation({
    mutationFn: (quizId: number) => fetcher(`${TrackingApi.InitQuiz}/${quizId}/session/create`),
    retry: false,
  })
}
